import { InputNumber } from "primereact/inputnumber";
import { TabView, TabPanel } from "primereact/tabview";
import React, { useState } from "react";
import ReactQuill from "react-quill-new";
import { reactQuillModules } from "utils/constants";
import { Editor } from "@monaco-editor/react";
import "react-quill-new/dist/quill.snow.css";

export interface FreeTextConfig {
  content: string;
  htmlContent?: string;
  height?: number;
  useHTMLCode?: boolean;
}

interface FreeTextEditorProps {
  config: FreeTextConfig;
  onConfigChange: (config: FreeTextConfig) => void;
}

const FreeTextEditor = ({ config, onConfigChange }: FreeTextEditorProps) => {
  const [activeIndex, setActiveIndex] = useState(config.useHTMLCode ? 1 : 0);

  const handleTabChange = (index: number) => {
    setActiveIndex(index);
    onConfigChange({ ...config, useHTMLCode: index === 1 });
  };

  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-column gap-2 w-2">
        <label htmlFor="height">Height (px)</label>
        <InputNumber
          id="height"
          value={config.height ?? undefined}
          onChange={e => onConfigChange({ ...config, height: e.value ?? undefined })}
        />
      </div>
      <TabView onTabChange={e => handleTabChange(e.index)} activeIndex={activeIndex}>
        <TabPanel header="Text Editor">
          <ReactQuill
            value={config.content}
            onChange={e => onConfigChange({ ...config, content: e })}
            modules={reactQuillModules}
          />
        </TabPanel>
        <TabPanel header="HTML Editor">
            <Editor
              language="html"
              theme="vs-dark"
              value={config.htmlContent || ""}
              height="300px"
              onChange={value => onConfigChange({ ...config, htmlContent: value ?? "" })}
              options={{
                formatOnPaste: true,
                padding: {
                  top: 10
              }
              }}
            />
        </TabPanel>
      </TabView>
      <h4 className="border-bottom-1 pb-2 mb-2">Preview</h4>
      <div
        className="quill-rendered-content bg-white p-3"
        style={{ border: "1px solid #ddd", minHeight: "150px" }}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: config.useHTMLCode ? (config.htmlContent ?? "") : (config.content ?? ""),
          }}
        />
      </div>
    </div>
  );
};

export default FreeTextEditor;
